import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import OptimusButton from '../../common/library/Button/Button';
import { TestIds } from '../../assets/testIds';

interface CoachComingSoonModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  body: string;
}

/**
 * Confirmation dialog shown after the user clicks "Join beta" or "Notify me"
 * on the AI Business Coach coming-soon card. Both CTAs share this component and
 * pass their own title/body copy. Mirrors the ConfidentialityModal layout.
 */
export function CoachComingSoonModal({
  open, onClose, title, body,
}: CoachComingSoonModalProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      data-testid={TestIds.coach.comingSoonConfirmModal}
      PaperProps={{
        sx: {
          borderRadius: theme.spacing(1),
          boxShadow: '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
          margin: {
            xs: theme.spacing(2),
            sm: theme.spacing(4),
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          padding: theme.spacing(3),
          paddingBottom: theme.spacing(2),
        }}
      >
        <Typography
          variant="headingMd"
          sx={{
            color: theme.palette.grey[900],
          }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: theme.spacing(0, 3, 2, 3),
        }}
      >
        <Typography
          variant="bodyMd"
          sx={{
            color: theme.palette.grey[700],
          }}
        >
          {body}
        </Typography>
      </DialogContent>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          padding: theme.spacing(2, 3, 3, 3),
        }}
      >
        <OptimusButton
          data-testid={TestIds.coach.comingSoonConfirmModalBtn}
          customVariant="link"
          buttonText={`${t('coach.comingSoon.gotIt')}`}
          fullWidth={false}
          onClick={onClose}
        />
      </Box>
    </Dialog>
  );
}
